import { render } from "./InvoiceHints.vue?vue&type=template&id=41fe6c08"
import script from "./InvoiceHints.vue?vue&type=script&lang=js"
export * from "./InvoiceHints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__